export default function sendDatalayerEvent(event, category, action){
  try {
    window.dataLayer.push({
      "event": event,
      "eventCategory": category,
      "eventAction": action,
    });
  } catch (err){
    console.error(err);
  }
}
